import React from 'react';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { HelpBox } from '../../../components/HelpBox/HelpBox';
import { shouldShowContactHelpBox } from 'utils/getHelpBoxConfig';

const Contact: React.FC = () => {
  const theme = ApiLocalStorage.get('theme') || {};
  // Por padrão mostra a helpbox, só esconde se show-contact-helpbox-fml for explicitamente false
  const showHelpBox = theme?.contact?.['show-contact-helpbox-fml'] !== false;

  return (
   <>
       <DynamicForm
         pageName="contact"
         initialValues={ApiLocalStorage.get('user-data')}
       >
           {showHelpBox && <HelpBox/>}
       </DynamicForm>
   </>
  );
};

export default Contact;
